function Item(props) {
    const {
        icon = null,
        details = null,
        action = null
    } = props;

    return (
        <div className="item">
            <div className="item__content">
                { icon !== null && <div className="item__icon">{ icon }</div> }
                { details !== null && details }
            </div>

            { action !== null && action }
        </div>
    )
}

export default Item;